export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      sidebar: {
        type: "compact-wrapper",
      },
      sidebar_setting: "default-sidebar",
    },
    color: {
      primary_color: "#196B28",
      secondary_color: "#070C1D",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
}
export default ConfigDB;
